<template>
	<div>
		<div class="wd-m-t-20 wd-m-b-20 tabdetail">
			<el-tabs type="border-card" v-model="tabindex" @tab-click="tapTab">
				<el-tab-pane label="全部">
				</el-tab-pane>
				<el-tab-pane label="处理中">
				</el-tab-pane>
				<el-tab-pane label="已处理">
				</el-tab-pane>
				<div>
					<el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
						<el-col :span="6" class="wd-text-center">售后单号</el-col>
						<el-col :span="12" class="wd-text-center">商品</el-col>
						<el-col :span="3" class="wd-text-center">状态</el-col>
						<el-col :span="3" class="wd-text-center">操作</el-col>
					</el-row>
					<el-row class="wd-theme-333 wd-border-bottom wd-flex wd-p-10" v-for="(item, index) in wddatalist" :key="index">
						<el-col :span="6" class="wd-text-center">{{item.listseqno}}</el-col>
						<el-col :span="12">
							<div  class="wd-flex wd-row-left wd-cursor" @click="gotogoodsdetail(item.goodsid, item.goodsname)" >
								<div class="img wd-row-noshrink"><el-image :src="$wdpicurl(item.goodspic)" class="img"></el-image></div>
								<div class="wd-row-grow wd-m-l-10 wd-text-left">{{ item.goodsname }}</div>
							</div>
						</el-col>
						<el-col :span="3" class="wd-text-center"><el-tag type="success">{{item.statetext}}</el-tag></el-col>
						<el-col :span="3" class="wd-text-center"><el-button type="warning" size="mini" @click="gotodetail(index)">查看</el-button></el-col>
					</el-row>
					<div class="wd-fr">
						<el-pagination
							:total="cnt"
							:background="true"
							layout="prev, pager, next"
							@size-change="pagesizechange"
							@current-change="currentchange"
							@prev-click="prevclick"
							@next-click="nextclick"
						></el-pagination>
					</div>
				</div>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Servicelist',
	data() {
		return {
			wddatalist: [],
			cnt: -1,
			page: 0,
			oldtabindex: 0,
			tabindex:0
		};
	},
	methods: {
		tapTab() {
			if (this.oldtabindex !== this.tabindex) {
				this.oldtabindex = this.tabindex;
				this.cnt=-1;
				this.wddatalist=[];
				this.loaddata();
			}
		},
		pagesizechange(e) {
			this.page=e-1;
			this.loaddata();
		},
		currentchange(e) {
			this.page=e-1;
			this.loaddata();
		},
		prevclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		nextclick(e) {
			this.page=e-1;
			this.loaddata();
		},
		loaddata() {
			if (this.cnt == -1) {
				this.page = 1;
			} else {
				if (this.page * this.$wd_limit >= this.cnt) {
					return;
				} else this.page++;
			}
			this.$wd_request('afterservicelist', { cnt: this.cnt, page: this.page,limit:this.$wd_limit,state:this.tabindex },true,".memdetail").then(data => {
				if (this.cnt == -1) {
					this.wddatalist = data.value;
					this.cnt=data.cnt;
				} else {
					this.wddatalist = data.value;
					// this.wddatalist = this.wddatalist.concat(data.value);
				}
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		gotodetail(index){
			console.log(index);
			
			let routeData = this.$router.resolve({
				name: 'Afterservicedetail',
				query: { detailid:this.wddatalist[index].id }
			});
			window.open(routeData.href, '_blank');
		}
	},
	activated() {
		this.loaddata();
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
.img {
	width: 50px;
	height: 50px;
}
</style>
